import React from 'react';
import {
  ProgressBar, Classes, Dialog,
} from '@blueprintjs/core';
import './progress-dialog.scss';

type Props = {
  title: string,
  open: boolean,
}

const ProgressDialog = ({
  title,
  open
}:Props) => {

  return (
    <div data-testid="ProgressDialog" className="progress-dialog">
      <Dialog isOpen={open}>
        <div className={Classes.DIALOG_HEADER}>
          {title}
        </div>
        <div className={Classes.DIALOG_BODY}>
          <ProgressBar intent="primary" value={0.5} />
        </div>
      </Dialog>
    </div>
  )
}

export default ProgressDialog;
